module.exports = __webpack_public_path__ + "c27229315c97e84a51b40c768737972d.pdf";